<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
    >
      <v-card-text>
        <span v-if='!estimate.field_instructions'>None...</span>
        <span v-html='estimate.field_instructions'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-textarea outlined auto-grow v-model='estimateCopy.field_instructions'></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'field-instructions',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    title: 'Field Instructions',
    icon: 'mdi-text-subject',
    iconColor: 'success',
    estimateCopy: [],
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showDialog = true
    },
    saveChanges () {
      this.$emit('update', this.estimateCopy)
      this.showDialog = false
    }
  }
}
</script>
